import { useDispatch, useSelector } from "react-redux";
import {
  selectThemeMode,
  setThemeMode,
  ThemeMode,
} from "../../../../../redux/features/theme/theme-slice";
import AppDropDown from "../../../ui-elements/app-dropdown/app-drop-down";
import { MtIcon } from "../../../ui-elements/material-icon/material-icon";
import styles from "./public-theme-dropdown.module.scss";

const PublicThemeDropdown = () => {
  const dispatch = useDispatch();
  const themeMode = useSelector(selectThemeMode);

  const handleThemeChange = (mode: ThemeMode) => {
    dispatch(setThemeMode(mode));
  };

  const getThemeIcon = (): MtIcon => {
    switch (themeMode) {
      case "dark":
        return "dark_mode";
      case "system":
        return "contrast";
      case "light":
      default:
        return "light_mode";
    }
  };

  const menuItems = [
    { text: "Light", onClick: () => handleThemeChange("light") },
    { text: "Dark", onClick: () => handleThemeChange("dark") },
    { text: "System", onClick: () => handleThemeChange("system") },
  ];

  return (
    <div className={styles.themeDropdownContainer}>
      <AppDropDown
        items={menuItems}
        icon={getThemeIcon()}
        buttonSize={20}
        hasDropdownBg={true}
        id="public-theme-dropdown-btn"
      />
    </div>
  );
};

export default PublicThemeDropdown;
